import { render, staticRenderFns } from "./ShowroomPaths.vue?vue&type=template&id=0ebe125d&scoped=true&"
import script from "./ShowroomPaths.vue?vue&type=script&lang=js&"
export * from "./ShowroomPaths.vue?vue&type=script&lang=js&"
import style0 from "./ShowroomPaths.vue?vue&type=style&index=0&id=0ebe125d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebe125d",
  null
  
)

export default component.exports